import { render, staticRenderFns } from "./UlasKandidat.vue?vue&type=template&id=263856cf&scoped=true&lang=html&"
import script from "./UlasKandidat.vue?vue&type=script&lang=js&"
export * from "./UlasKandidat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263856cf",
  null
  
)

export default component.exports